<template>
  <div class="timeline-container">
    <h3 class="timeline-title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12,6 12,12 16,14"></polyline>
      </svg>
      Próximos Passos
    </h3>

    <div class="timeline">
      <div v-for="(step, index) in steps" :key="index" class="timeline-item" :class="{ 'active': step.active, 'completed': step.completed }">
        <div class="timeline-marker">
          <div class="marker-circle">
            <svg v-if="step.completed" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20,6 9,17 4,12"></polyline>
            </svg>
            <span v-else class="step-number">{{ index + 1 }}</span>
          </div>
        </div>

        <div class="timeline-content">
          <h4 class="step-title">{{ step.title }}</h4>
          <p class="step-description">{{ step.description }}</p>
          <div v-if="step.details" class="step-details">
            <p>{{ step.details }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineComponent',
  props: {
    currentStep: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      steps: [
        {
          title: 'Pedido Enviado',
          description: 'Seu pedido de cotação foi enviado com sucesso!',
          details: 'Recebemos todos os seus dados e informações do veículo.',
          completed: true,
          active: false
        },
        {
          title: 'Análise em Andamento',
          description: 'Nossa equipe está analisando sua solicitação.',
          details: 'Em até 24 horas úteis, retornaremos no seu e-mail com o link para acessar a cotação, este link também estará disponível no seu E-Trade na parte de seguros.',
          completed: false,
          active: true
        },
        {
          title: 'Cotação Disponível',
          description: 'Acesse sua cotação através do link enviado.',
          details: 'Você receberá um e-mail com o link para visualizar e aprovar o seguro desejado.',
          completed: false,
          active: false
        },
        {
          title: 'Aprovação do Seguro',
          description: 'Escolha e aprove o seguro que melhor atende suas necessidades.',
          details: 'Compare as opções disponíveis e selecione a cobertura ideal.',
          completed: false,
          active: false
        },
        {
          title: 'Apólice Enviada',
          description: 'Sua apólice será enviada por e-mail e no sistema E-Trade.',
          details: 'O documento oficial do seu seguro estará disponível em ambos os locais.',
          completed: false,
          active: false
        }
      ]
    }
  },
  watch: {
    currentStep(newStep) {
      this.updateSteps(newStep)
    }
  },
  mounted() {
    this.updateSteps(this.currentStep)
  },
  methods: {
    updateSteps(currentStep) {
      this.steps.forEach((step, index) => {
        step.completed = index < currentStep
        step.active = index === currentStep
      })
    }
  }
}
</script>

<style scoped>
.timeline-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
}

.timeline-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
  color: #244179;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  justify-content: center;
}

.timeline {
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #244179, #F7D810);
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  padding-left: 4rem;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: 0;
  top: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.marker-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  border: 3px solid;
}

.timeline-item.completed .marker-circle {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.timeline-item.active .marker-circle {
  background: #244179;
  border-color: #244179;
  color: white;
  animation: pulse 2s infinite;
}

.timeline-item:not(.completed):not(.active) .marker-circle {
  background: white;
  border-color: #e9ecef;
  color: #6c757d;
}

.step-number {
  font-weight: 600;
}

.timeline-content {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.timeline-item.active .timeline-content {
  border-color: #244179;
  box-shadow: 0 4px 20px rgba(36, 65, 121, 0.15);
}

.timeline-item.completed .timeline-content {
  border-color: #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #ffffff 100%);
}

.step-title {
  margin: 0 0 0.5rem 0;
  color: #244179;
  font-size: 1.125rem;
  font-weight: 600;
}

.timeline-item.completed .step-title {
  color: #28a745;
}

.step-description {
  margin: 0 0 0.75rem 0;
  color: #495057;
  font-size: 0.875rem;
  line-height: 1.5;
}

.step-details {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.75rem;
  border-left: 4px solid #F7D810;
}

.step-details p {
  margin: 0;
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(36, 65, 121, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(36, 65, 121, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(36, 65, 121, 0);
  }
}

@media (max-width: 768px) {
  .timeline-container {
    padding: 1rem;
  }

  .timeline-item {
    padding-left: 3rem;
  }

  .timeline-marker {
    width: 30px;
    height: 30px;
  }

  .marker-circle {
    width: 30px;
    height: 30px;
    font-size: 0.75rem;
  }

  .timeline::before {
    left: 15px;
  }

  .timeline-content {
    padding: 1rem;
  }

  .step-title {
    font-size: 1rem;
  }

  .step-description {
    font-size: 0.8rem;
  }
}
</style>
